{
  "achievement-center": "مركز الإنجازات",
  "admin": "الإدارة",
  "admin-learn": "تعلم واربح - إدارة",
  "admin-p2p": "إدارة P2P",
  "admin-referrals": "إدارة الإحالات",
  "admin-rewards": "إدارة المكافآت",
  "ai-arbitrage-scanner": "ماسح المراجحة الذكي",
  "ai-assistant": "مساعد التداول الذكي",
  "ai-copy-trading": "نسخ التداول بالذكاء الاصطناعي",
  "ai-grid-trading": "تداول الشبكة الذكي",
  "ai-launchpad": "منصة الإطلاق الذكية",
  "ai-market-scanner": "ماسح السوق الذكي",
  "ai-news": "أخبار الذكاء الاصطناعي",
  "ai-portfolio": "مدير المحفظة الذكي",
  "ai-profit-calculator": "حاسبة الأرباح الذكية",
  "ai-risk-manager": "مدير المخاطر الذكي",
  "ai-smart-alerts": "تنبيهات ذكية",
  "ai-trust-score": "درجة الثقة الذكية",
  "ai-whale-alerts": "تنبيهات الحيتان الذكية",
  "ai-whale-heatmap": "خريطة الحيتان الحرارية",
  "ai-whale-tracker": "تتبع الحيتان الذكي",
  "buy": "شراء",
  "certificates": "شهاداتي",
  "dashboard": "لوحة التحكم",
  "exalt-utility-center": "مركز خدمات إكسالت",
  "futures": "العقود المستقبلية",
  "kyc": "طلبات التحقق",
  "kyc-submit": "إرسال KYC",
  "learnearn": "تعلم واربح",
  "listings": "الإدراجات",
  "markets": "الأسواق",
  "notification-center": "مركز الإشعارات",
  "orders": "الأوامر",
  "p2p": "تداول P2P",
  "profile": "الملف الشخصي",
  "referral": "الإحالات",
  "reputation-center": "سمعة المجتمع",
  "rewards": "المكافآت",
  "settings": "الإعدادات",
  "social-trading": "التداول الاجتماعي",
  "spotTrading": "التداول الفوري",
  "staking": "الستاكينغ",
  "support": "الدعم",
  "trade": "تداول",
  "transactions": "سجل المعاملات",
  "wallets": "المحافظ",
  "web3wallet": "محفظة Web3"
}